/* eslint-disable no-undef */
export default {
	name: "from-date-to-date-pickers",
	props: ["title", "fromDate", "toDate", "elementId", "dateFormat", "hideClearButton", "initialiseDate", "initialiseDatePickerEndDate"],
	emits: ["fromDateSelected", "toDateSelected", "clearDatePicker"],
	data() {
		return {
			heading: null,
			componentFromDate: null,
			componentToDate: null
		};
	},
	methods: {
		onFromDateCreatedSelect(date){
			this.componentFromDate = date;
			this.$emit("fromDateSelected", this.componentFromDate);
		},
		onToDateCreatedSelect(date){
			this.componentToDate = date;
			this.$emit("toDateSelected", this.componentToDate);
		},
		onDateSelectClearClick(){
			console.log("clear clicked");
			this.$emit("clearDatePicker", true);
		}
	},
	mounted: function () {
		
	},
	watch: {
		title: {
			handler: function () {
				if(this.title){
					this.heading = this.title;
				}
			},
			immediate: true,
			deep: true
		},
		fromDate: {
			handler: function () {
				if(this.fromDate){
					this.componentFromDate = this.fromDate;
				}
				else{
					this.componentFromDate = null;
				}
			},
			immediate: true,
			deep: true
		},
		toDate: {
			handler: function () {
				if(this.toDate){
					this.componentToDate = this.toDate;
				}
				else{
					this.componentToDate = null;
				}
			},
			immediate: true,
			deep: true
		}
	}
};